module.exports = __webpack_public_path__ + "img/bg.b30b3bae.png";